export const CHART_AXIS_STROKE = "#D8D8D8";
export const CHART_AXIS_TICK = "#727272";
export const CHART_GRID_STROKE = "#ECECEC";

export const CHART_PALETTE = {
  primary: "#7562A8",
  secondary: "#54A6AA",
  tertiary: "#A86392",
  success: "#0AAB51",
  warning: "#EB9144",
  caution: "#FBBC21",
  error: "#E11D3F",
};

export const CHART_DONUT_COLORS = [
  CHART_PALETTE.primary,
  CHART_PALETTE.secondary,
  CHART_PALETTE.caution,
  CHART_PALETTE.warning,
  CHART_PALETTE.tertiary,
];

export const CHART_AXIS_TICK_STYLE = {
  fill: CHART_AXIS_TICK,
  fontSize: 11,
  fontFamily: "'Open Sans', sans-serif",
};

function getTickStep(total: number): number {
  if (total > 60) return 14;
  if (total > 20) return 5;
  return 1;
}

export function formatDateTick(
  date: string,
  index: number,
  total: number
): string {
  if (index % getTickStep(total) !== 0) return "";
  return new Date(date).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
  });
}
